import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './PdpRespPreviewMessageBanner.scss';

function launchPrintDialogue() {
    if (typeof window !== 'undefined') {
        window.print();
    }
}

function PdpRespPreviewMessageBanner() {
    return (
        <div className={styles.banner}>
            <div className={styles.message}>
                <FormattedMessage
                    id="PdpRespPreviewMessageBanner.pageInfo"
                    defaultMessage="You're viewing a work in progress. {clickHereCta} to print."
                    values={{
                        clickHereCta: (
                            <a
                                onClick={launchPrintDialogue}
                                className={`${styles.printLink} enable-click-on-preview`}
                            >
                                <FormattedMessage
                                    id="PdpRespPreviewMessageBanner.clickHere"
                                    defaultMessage="Click here"
                                />
                            </a>
                        ),
                    }}
                />
            </div>
        </div>
    );
}

export { PdpRespPreviewMessageBanner };
